import { render } from "./LegacyClaimDetail.vue?vue&type=template&id=31c187d8"
import script from "./LegacyClaimDetail.vue?vue&type=script&lang=js"
export * from "./LegacyClaimDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__